module.exports = __webpack_public_path__ + "static/media/test-renderer.9e7edb1a.png";